import { makeStyles } from "@material-ui/core/styles";
import myTheme from "../../themes/palette";

const useStyles = makeStyles((theme) => ({
  mainAboutusContainer: {
    paddingLeft: theme.spacing(myTheme.padding.left + 3.4),
    paddingRight: theme.spacing(myTheme.padding.right + 3.4),
    [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
  bCrumbLink: {
    "text-decoration": "none",
    "&:hover": {
      color: "black",
      "text-decoration": "none",
    },
  },
  userDetailsHeaderArea: {
    paddingBottom: 15,
    borderBottom: "1px solid #e1e1e1",
    padding: 20,
    [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
      padding: 4,
    },
  },
  root: {
    paddingLeft: theme.spacing(myTheme.padding.left + 3.4),
    paddingRight: theme.spacing(myTheme.padding.right + 3.4),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "stretch",
    [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
      paddingTop: theme.spacing(0),
      paddingBottom: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
  leftSideBar: {
    height: "82vh",
    marginBottom: "30px",
  },
  MainChatArea: {
    height: "82vh",
    width: "100%",
    marginBottom: "30px",
    position: "relative",
    paddingLeft: 5,
    paddingRight: 5,
    [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
      height: "92vh",
    },
  },
  badge: {
    backgroundColor: "red",
    color: "#fff",
    display: "inline-block",
    paddingLeft: "8px",
    paddingRight: "8px",
    textAlign: "center",
    borderRadius: "50%",
  },
  flexContainer: {
    padding: 0,
    margin: "auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  rowItem: {
    paddingLeft: 60,
    paddingRight: 60,
  },
  table: {
    minWidth: 650,
    [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
      overflow: "scroll",
      height: "95%",
    },
  },
  closeBtn: {
    marginRight: 20,
    position: "absolute",
    top: 20,
    right: 5,
	[theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
		top:3,
		right:2
	  },
  },
  searchBtn: {
    marginTop: 16,
    padding: 7.6,
    paddingLeft: 15,
    paddingRight: 15,
    [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
      marginTop: 0,
    },
  },
  seatchUsersBox: {
    padding: "40px",
    maxWidth: "70vw",
    height: "84vh",
    position: "relative",
    [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
      maxWidth: "95%",
      height: "100%",
    },
  },
  searchingModal: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
      position: "absolute",
      top: "10%",
      left: "10%",
      overflow: "scroll",
      height: "95%",
      display: "block",
      backgroundColor: "white",
      borderRadius: "10px",
      boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
      margin: "4%",
    },
  },
  searchedUsersTable: {
    height: "53vh",
    [theme.breakpoints.down(myTheme.breakpoints.values.sm)]: {
      overflow: "scroll",
      height: "100%",
	  maxHeight:'370px'
    },
  },
}));

export default useStyles;
